import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import style from '../../../css/dashboard/landing_dash/DashboardLanding.module.css'


import LandingChart from '../../Dashboard/landing_dash/chart_landing';
import Fii_Dii_data from './Fii_Dii_data';
import TelegramCard from './TelegramCard ';

const DashboardLanding = () => {

    const [fullName, setFullName] = useState('');

    useEffect(() => {
        // Retrieve the stored user name from localStorage
        const storedFullName = localStorage.getItem('fullName');

        if (storedFullName) {
            setFullName(storedFullName);
        }
    }, []);

    // Adjust scroll position to account for fixed navbar

    const navigate = useNavigate();

    const scrollToSection = (sectionId) => {
        setTimeout(() => {
            const section = document.getElementById(sectionId);
            if (section) {
                window.scrollTo({
                    top: section.offsetTop - 150,  // Adjust the offset to match your navbar height
                    behavior: 'smooth',
                });
            }
        }, 10);
    };

    const scrolltocourses = (e) => {
        e.preventDefault();
        navigate('/');
        scrollToSection('coursesbuyy');

    };



    return (
        <>

            <div className={`container-fluid   ${style.landing_dash_container}`}>
                <div className="row" >
                    <div className="col-md-8">
                        <LandingChart />
                    </div>
                    <div className={`col-md-4  ${style.landing_dash_col}`}>
                        <Fii_Dii_data />
                        {/* <SuccessAnalysisCard /> */}
                    </div>
                </div>
                <div className="d-flex justify-content-end">
                    <TelegramCard />
                </div>
            </div>


        </>
    )
}

export default DashboardLanding